<script lang="ts" setup>
  import { PropType, toRefs } from "vue";

  import { useAsModalChildProps } from "frontend/uses/simple-modal/use-simple-modal";
  import { Note } from "frontend/interfaces/note";
  import { ErrorDatabase, useErrors } from "frontend/uses/use-errors";

  import FormDatetime from "frontend/components/form/FormDatetime.vue";
  import FormInput from "frontend/components/form/FormInput.vue";
  import FormSelectOfficePerson from "frontend/components/form/FormSelectOfficePerson.vue";
  import FormOfficeColor from "frontend/components/form/FormOfficeColor.vue";
  import BaseSpinner from "frontend/components/base/BaseSpinner.vue";

  const props = defineProps({
    ...useAsModalChildProps(),
    note: {
      type: Object as PropType<Note>,
      required: true,
    },
    editMode: {
      type: Boolean,
      required: true,
    },
    errorDatabase: {
      type: Object as PropType<ErrorDatabase>,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  });
  const { errorDatabase, note } = toRefs(props);
  const { errorFor } = useErrors(errorDatabase);
</script>

<template>
  <div v-bind:class="{ 'aad-note--as-modal': asModalChild }">
    <h3>Tagesnotiz</h3>
    <FormInput
      v-model="note.name"
      label="Titel"
      v-bind:errors="errorFor('name')"
      visual-small
    />
    <div class="columns">
      <FormDatetime
        v-model="note.from"
        class="columns__column"
        label="Von"
        v-bind:allow-deletion="false"
        visual-small
      />
      <FormDatetime
        v-model="note.to"
        class="columns__column"
        label="Bis"
        v-bind:allow-deletion="false"
        visual-small
        v-bind:errors="errorFor('to')"
      />
    </div>
    <FormOfficeColor v-model="note.color_id" label="Farbe" allow-blank />
    <FormSelectOfficePerson
      v-model="note.client_resources.persons"
      label="Mitarbeiter"
      v-bind:errors="errorFor('client_resources')"
    />
    <div class="add-note__errors"></div>
    <div v-if="isLoading" class="add-note__loading">
      <BaseSpinner />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .columns {
    display: flex;
  }

  .columns__column {
    flex: 1;
    margin-right: 20px;

    &:last-of-type {
      margin-right: 0;
    }
  }
  .add-note__loading {
    margin-top: 50px;
  }

  .add-note__errors {
    margin-top: 25px;
  }
</style>
